import Vue from 'vue'


/**
 * 格式化日期
 * @param date
 * @param type
 * @returns {string}
 */
Vue.filter('format', (value, type) => {
  if (!value) return '';
  
  const formats = {
    2: 'Y-M',
    3: 'Y年M月',
    4: 'Y-M-D',
    5: 'M-D H:m',
    6: 'Y-M-D',
    7: 'Y.M.D',
    8: 'M.D',
    9: 'Y/M/D',
    10: 'Y年M月D日',
    default: 'Y-M-D H:m'
  };

  return DateFormatter.format(value, formats[type] || formats.default);
})

/**
 * 格式化日期为原始格式
 */
Vue.filter('formatToOriginalFormat', value => {
  if (!value) return '';
  return DateFormatter.format(value, 'Y/M/D H:m:s');
});



/**
 * 修改聊天时间显示过滤器
 */
Vue.filter('chatTime', value => {
  if (!value) return '';
  // return DateFormatter.format(value, 'H:m');
  return DateFormatter.format(value, 'Y-M-D H:m');
})

/**
 * 消息时间显示过滤器 - 格式为 MM-DD HH:mm
 */
Vue.filter('messageTime', value => {
  if (!value) return '';
  return DateFormatter.format(value, 'M-D H:m');
})

/**
 * 判断聊天记录是否显示时间的方法
 */
Vue.prototype.$shouldShowChatTime = function(currentTime, prevTime) {
  if (!prevTime) return true;
  
  const current = new Date(currentTime).getTime();
  const prev = new Date(prevTime).getTime();
  return (current - prev) > 180000;
}


/**
 * 日期格式化工具类
 */
class DateFormatter {
  static pad(num) {
    return String(num).padStart(2, '0');
  }

  static getDateParts(date) {
    return {
      Y: date.getFullYear(),
      M: this.pad(date.getMonth() + 1),
      D: this.pad(date.getDate()),
      H: this.pad(date.getHours()),
      m: this.pad(date.getMinutes()),
      s: this.pad(date.getSeconds())
    };
  }

  static format(date, format) {
    if (!date) return '';
    const parts = this.getDateParts(new Date(date));
    return format.replace(/Y|M|D|H|m|s/g, match => parts[match]);
  }

  /**
   * 中文日期：YYYY年M月D日（不补零）
   */
  static formatCN(date) {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = d.getMonth() + 1;
    const day = d.getDate();
    return `${m}月${day}日`;
    // return `${y}年${m}月${day}日`;  
  }

  /**
   * 获取指定天数后的时间
   * @param {number} days - 指定的天数
   * @param {Date|string} [startDate] - 开始时间，默认为当前时间
   * @param {string} [format] - 输出格式，默认为 'Y-M-D H:m'
   * @returns {string} 返回格式化后的时间字符串
   */
  static getTimeAfterDays(days, startDate = new Date(), format = 'Y-M-D H:m') {
    const start = startDate instanceof Date ? startDate : new Date(startDate);
    const targetDate = new Date(start.getTime() + days * 24 * 60 * 60 * 1000);
    return this.format(targetDate, format);
  }

  /**
   * 格式化日期为相对时间（今天、昨天等）
   * @param {Date|string} date - 日期
   * @returns {string} 返回相对时间字符串
   */
  static formatRelativeTime(date) {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today.getTime() - 86400000);
    const sevenDaysAgo = new Date(today.getTime() - 7 * 86400000);
    const thirtyDaysAgo = new Date(today.getTime() - 30 * 86400000);
    
    const itemDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    
    if (itemDate.getTime() === today.getTime()) {
      return '今天';
    } else if (itemDate.getTime() === yesterday.getTime()) {
      return '昨天';
    } else if (itemDate >= sevenDaysAgo) {
      return '7天内';
    } else if (itemDate >= thirtyDaysAgo) {
      return '30天内';
    } else {
      return '30天以上';
    }
  }
}

export { DateFormatter }
